export interface Document {
    uuid: string;
    doc_name?: string;
    filename?: string;
    client_id?: string;
    source?: string;
    source_documents?: any;
    type?: string;
    request_type?: string;
}

export interface ExportStatus {
    export_id?: string;
    status: 'pending' | 'processing' | 'completed' | 'failed';
    message: string;
    created_at?: string;
    started_at?: string;
    completed_at?: string;
    success?: boolean;
}

export interface GruntWorxExportPickerProps {
    selectedRecords: Document[];
    cancelWidget: () => void;
}

export interface InvalidDocument extends Document {
    invalidReason: string;
}

export const ALLOWED_FORMATS = ['.pdf', '.zip', '.jpg', '.jpeg', '.png'] as const;
export type AllowedFormat = typeof ALLOWED_FORMATS[number];

export const MAX_POLL_ATTEMPTS = 10;
export const POLL_INTERVAL_PENDING = 5000;
export const POLL_INTERVAL_PROCESSING = 2000;
export const POLL_INTERVAL_FAILED = 10000;